import { contentLabels, contentPaths } from "../../../utils/static";
import clsx from "clsx";
import { IAssignedTask, TTask } from "../../../types/generalTypes";
import { slugify } from "../../../utils/urlConversion";
import { useSqids } from "../../../hooks/useSqids";
import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { myAxios } from "../../../utils/common";
import { toast } from "react-toastify";
import { add, format, isMonday } from "date-fns";

function findNextMonday() {
  let date = new Date();
  while (!isMonday(date)) {
    date = add(date, { days: 1 });
  }
  return date;
}

export default function NotAssignedTaskItem({
  item,
  mcId,
}: {
  item: IAssignedTask;
  mcId?: number;
}) {
  const sqids = useSqids();
  const [pDate, setPDate] = useState<string | null>(format(findNextMonday(), "yyyy-MM-dd") + "T09:00",);

  const queryClient = useQueryClient();
  const assignContentMutation = useMutation({
    mutationFn: async (data: {
      module_cohort_id: number,
      content_type: TTask,
      content_id: number,
      planning_date: string;
    }) =>
      myAxios.post("/module_cohort_content/", data).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["moduleContents", { "mcId": mcId }]
      });
      toast.success("Content eklendi");
    },
  });

  let linkArea: null | React.ReactNode = null;

  if (item.tag === "UNIT") {
    linkArea = item.name;
  } else if (item.tag === "PROJECT") {
    const { id, infos, tag, environment, project_url } = item;
    linkArea = <div>{infos.title}</div>;

    if (environment === "GITHUB") {
      linkArea = (
        <a href={project_url} rel="noopener noreferrer" target="_blank">
          {infos.title}
        </a>
      );
    } else if (environment === "SANDPACK") {
      linkArea = (
        <a
          href={`/${contentPaths[tag]}/${slugify(infos.title)}-${sqids.encode(id)}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          {infos.title}
        </a>
      );
    }
  } else if (item.tag === "LIVE_EVENT") {
    linkArea = (
      <div>
        {item.name}{" "}
        <span className="text-white/50">({item.duration} dakika)</span>
      </div>
    );
  }

  function assign() {
    if (pDate) {
      const localDateTime = new Date(pDate);
      const utcDateTime = localDateTime.toISOString();

      const toSend = {
        module_cohort_id: mcId!,
        content_type: item.tag,

        content_id: item.id,
        planning_date: utcDateTime,
      };

      assignContentMutation.mutate(toSend)
    }
  }

  return (
    <div className={clsx("flex items-center py-1.5 text-sm gap-2")}>
      <div
        className={clsx(
          "w-12 uppercase tracking-tight pt-0.5 font-mono font-medium text-[13px]/4",
          item.tag === "UNIT" && "text-amber-400/80",
          item.tag === "PROJECT" && "text-myOrange/80",
          item.tag === "LIVE_EVENT" && "text-myGreen/60"
        )}
      >
        {contentLabels[item.tag]}
      </div>
      <div className="flex-1">{linkArea}</div>
      <div className="">
        <input
          className="flex-1 border border-white/20 bg-white/10 p-1.5 rounded"
          onChange={(e) => setPDate(e.target.value)}
          value={pDate!}
          type="datetime-local"
        />
      </div>
      <button onClick={assign} disabled={!pDate} className="bg-myBlue px-2.5 py-1.5 cursor-pointer rounded disabled:bg-myBlack disabled:cursor-not-allowed">
        Ekle
      </button>
    </div>
  );
}
